var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoType = function SvgLogoType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 150 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "logo-type_svg__logoPath",
    clipPath: "url(#logo-type_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EF3B36",
    fillRule: "evenodd",
    d: "m36.6 24-4.2-4.5v.2l-.6 4.4h4.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF3B36",
    fillRule: "evenodd",
    d: "m26.7 21 4.9 4.8.2-1.7.6-4.4v-.2zm4.9 4.8L20 35.7l.1.3 11.2-7.5.3-2.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF3B36",
    d: "M15.9 25.7v.2l-2.2 17 6.6-6.5-.2-.5-.1-.3-4-9.8h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#034EA2",
    d: "M26.7 21 16.5 10.8h-.1l-.5 15 4 9.8L31.6 26h.1l-4.9-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBB5B4",
    fillRule: "evenodd",
    d: "m15.9 25.8-7.5-8-8-.3 15.4 8.4v-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2E0DF",
    fillRule: "evenodd",
    d: "m15.9 25.8.5-15-14.2.2 6.2 6.7 7.5 8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF3B36",
    d: "M28.7 48.1a24 24 0 0 1-15-5.2l1-1.4a22.4 22.4 0 0 0 28.1-.3l1.2 1.4A24 24 0 0 1 28.7 48Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#034EA2",
    d: "M45.6 41.1 44.4 40a22 22 0 0 0 4-26.1l1.5-.8A24 24 0 0 1 45.6 41Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2E0DF",
    d: "M47 11.7a22.2 22.2 0 0 0-27-8l-.8-1.6a23.8 23.8 0 0 1 29.4 8.6l-1.5 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#034EA2",
    d: "M65 12.9h3.6a2.8 2.8 0 0 0-2.8-2.2c-1 0-1.8.5-2.3 1.3l-1.2-.9a4.4 4.4 0 1 1 0 5l1.2-.8c.5.8 1.3 1.3 2.3 1.3 1.6 0 2.7-1 2.9-2.5H65V13Zm8.8-3.5v3.4h.7l2.7-3.4H79l-3.2 4c1 .3 1.6 3.1 3 3.1h.5v1.4a3 3 0 0 1-.7 0c-2.3 0-3-3.6-4.1-3.7h-.7v3.7h-1.5V9.4zm25.2 0V18h-1.5v-7h-4.3v7h-1.5V9.4zm6.7 8.5h-4.4V9.4h4.4v1.4h-3v2h2.8v1.4h-2.7v2.3h3v1.4Zm4.6-8.5a2.8 2.8 0 1 1 0 5.5h-1.2v3h-1.5V9.4h2.8Zm-1.2 4.2h1c.9 0 1.6-.6 1.6-1.4s-.7-1.4-1.5-1.4H109v2.8Zm11.9-2.8h-2.7v7h-1.5v-7h-2.5V9.4h6.6v1.4Zm3-1.4v3.4h4.4V9.4h1.5V18h-1.5v-3.7h-4.3V18h-1.5V9.4h1.5Zm11 8.5h-2.8V9.4h1.5v3.2h1.4c1.5 0 2.7 1.1 2.7 2.6S136.7 18 135 18Zm-.1-4h-1.2v2.6h1.2c.8 0 1.4-.5 1.4-1.3 0-.7-.6-1.2-1.4-1.2Zm3.8-4.5h1.5V18h-1.5zm3.8 0h1.5v5.8l4.3-5.8h1.3V18H148v-6l-4.4 5.8h-1.2V9.4Zm-73.3 16a2.8 2.8 0 0 0-2.4-1.2 2.8 2.8 0 0 0-2.9 3c0 1.5 1.2 2.8 2.9 2.8 1 0 1.9-.5 2.4-1.2l1.2.8a4.4 4.4 0 1 1 0-5zm6.8-2.7c2.5 0 4.4 2 4.4 4.4s-2 4.4-4.3 4.4c-2.5 0-4.4-2-4.4-4.4s2-4.4 4.4-4.4Zm0 7.3c1.7 0 2.9-1.3 2.9-2.9s-1.2-3-2.8-3c-1.7 0-2.9 1.4-2.9 3s1.2 3 2.9 3Zm9.3-7c1.3 0 2.2.8 2.2 2a2 2 0 0 1-1.3 2c1.2.2 1.8 1.1 1.8 2 0 1.3-1 2.3-2.5 2.3h-3V23zm-1.4 3.4h1c.7 0 1.2-.5 1.2-1.1 0-.7-.5-1.1-1.3-1.1H84v2.2Zm0 3.7H85c.8 0 1.5-.5 1.5-1.3 0-.7-.6-1.2-1.5-1.2h-1V30Zm10.4 1.2H90V23h4.4v1.4h-3v2h2.8v1.4h-2.8V30h3v1.3Zm7.9-7h-2.6v7h-1.4v-7h-2.6v-1.4h6.6zm8.3 7h-3V23h4.8v1.3H109v2h1.5c1.4 0 2.5 1.2 2.5 2.6 0 1.5-1 2.5-2.5 2.5Zm-.4-3.7H109V30h1.1c.9 0 1.4-.4 1.4-1.2 0-.7-.5-1.2-1.4-1.2m7.6-4.6c1.5 0 2.8 1.1 2.8 2.7 0 1.5-1.3 2.7-2.8 2.7h-1.3v3h-1.5v-8.5h2.8Zm-1.3 4h1c.9 0 1.6-.5 1.6-1.3s-.7-1.4-1.5-1.4h-1.1zm5.9-4h1.4v5.7l4.4-5.8h1.2v8.4H128v-5.8l-4.4 5.8h-1.2V23Zm10.8 0v3.3h.8l2.6-3.4h1.8l-3.2 4c1.1.2 1.7 3 3.1 3h.4v1.4a3 3 0 0 1-.7.1c-2.3 0-3-3.7-4.1-3.7h-.7v3.6h-1.5V23zm13.2 2.4a2.8 2.8 0 0 0-2.4-1.2 2.8 2.8 0 0 0-2.9 3c0 1.5 1.2 2.8 3 2.8 1 0 1.8-.5 2.3-1.2l1.2.8a4.4 4.4 0 1 1 0-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF3B36",
    d: "M63.6 41.6v3.2h-1v-8.4H65c1.5 0 2.6 1.1 2.6 2.6 0 1.4-1.1 2.6-2.6 2.6zm1.3-.9c1 0 1.8-.7 1.8-1.7s-.8-1.7-1.8-1.7h-1.3v3.4zm8.5-4.5c2.4 0 4.3 2 4.3 4.4s-2 4.4-4.3 4.4c-2.4 0-4.3-2-4.3-4.4s1.9-4.4 4.3-4.4m0 7.8c2 0 3.3-1.5 3.3-3.4 0-2-1.4-3.5-3.3-3.5-2 0-3.4 1.6-3.4 3.5s1.4 3.4 3.4 3.4m6.3-3.4a4.4 4.4 0 0 1 8-2.5l-.8.5a3.4 3.4 0 0 0-2.8-1.5c-2 0-3.4 1.6-3.4 3.5S82 44 84 44c1.2 0 2.2-.5 2.8-1.4l.8.5a4.4 4.4 0 0 1-8-2.5Zm9.5 0a4.4 4.4 0 0 1 8-2.5l-.8.5a3.4 3.4 0 0 0-2.8-1.5c-2 0-3.5 1.6-3.5 3.5s1.5 3.4 3.5 3.4c1.2 0 2.2-.5 2.8-1.4l.7.5a4.4 4.4 0 0 1-8-2.5Zm10.9 2.6 4.8-6.8h1v8.4h-1V38l-4.8 6.8h-1v-8.4h1zm11.5-1.6c-.8.3-1.3 3.2-3.3 3.2h-.5v-1h.3c1.2 0 1.8-2.1 2.4-2.3a2.5 2.5 0 0 1-2.1-2.5c0-1.5 1.2-2.6 2.7-2.6h2.4v8.4h-1v-3.2h-1Zm1-1v-3.3h-1.4c-1 0-1.9.7-1.9 1.7s.8 1.7 1.9 1.7h1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF3B36",
    fillRule: "evenodd",
    d: "M148 7.4 144.3 2v5.5h3.9Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2E0DF",
    d: "M87.9 11.1a3.4 3.4 0 0 0-4.7-.1l-.9-1a4.8 4.8 0 0 1 6.6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF3B36",
    d: "M81.8 16.6a4.8 4.8 0 0 1 0-6.2l1 .9c-1 1.3-1 3.1 0 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#034EA2",
    d: "M85.5 18.3c-1.2 0-2.3-.4-3.2-1.2l.9-1a3.4 3.4 0 0 0 4.7-.2l1 1c-1 1-2.2 1.4-3.4 1.4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-type_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h150v48H0z"
  })))));
};
export default SvgLogoType;